import axios from '../../axios/index.js'

export default {
  ehsTableList() {
    return axios.get('ehs/dashboardList')
  },
  ehsTableMatrix() {
    return axios.get('ehs/dashboard')
  },
  list(data) {
    return axios.post('ehs/list', data)
  },
  store(data) {
    return axios.post('ehs/store', data, { headers: { 'Content-Type': 'multipart/form-data' }, processData: false, contentType: false })
  },
  delete(id) {
    return axios.delete('ehs/delete', { params: { id } })
  },
  update(data) {
    return axios.put('ehs/update', { id: data.id, [data.column]: data.value })
  },
  updateExpiration(data) {
    return axios.post('ehs/expiration_date', data, { headers: { 'Content-Type': 'multipart/form-data' }, processData: false, contentType: false })
  },
  getFacilities(client_id = null) {
    return axios.get('ehs/getFacilities', { params: { client_id } })
  },
  getTypes(data) {
    return axios.get('ehs/getTypes', { params: data })
  },
  getStatusList() {
    return axios.get('ehs/status')
  },
  getSoonToExpired() {
    return axios.get('ehs/get_soon_to_expired')
  }
}
